import { Instagram, MessageCircle, Phone, Mail, Globe, MapPin } from "lucide-react";
import { FL } from "@/constants/testIds/fairylights";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      id="footer"
      data-testid={FL.footer}
      className="relative overflow-hidden border-t border-[#D4AF37]/25 bg-[#1A050B] px-6 pt-20 pb-10 sm:px-10 md:px-14"
    >
      <div className="pointer-events-none absolute -bottom-24 -right-24 h-[380px] w-[380px] rounded-full bg-[#D4AF37]/10 blur-3xl" />
      <div className="pointer-events-none absolute -top-32 -left-32 h-[420px] w-[420px] rounded-full bg-[#4A0E1F] blur-3xl" />

      <div className="relative mx-auto grid max-w-6xl grid-cols-1 gap-12 md:grid-cols-[1.5fr_1fr_1fr] md:gap-16">
        <div>
          <div className="font-serif text-6xl italic leading-none text-[#D4AF37] md:text-7xl">
            Fairy Lights
          </div>
          <p className="mt-6 max-w-sm font-body text-[14px] leading-[1.75] text-[#FDFBF7]/70">
            A Dubai-based atelier of light, bloom & ceremony. Composing weddings,
            galas and private moments across the UAE since 2015.
          </p>
          <div className="mt-8 flex items-center gap-3">
            <a
              href="https://instagram.com/fairylights.uae"
              target="_blank"
              rel="noreferrer"
              data-testid={FL.igLink}
              className="pill pill-ghost"
              aria-label="Instagram"
            >
              <Instagram className="h-4 w-4" />
              Instagram
            </a>
            <a
              href="https://wa.me/971528035188"
              target="_blank"
              rel="noreferrer"
              data-testid={FL.waLink}
              className="pill pill-ghost"
              aria-label="WhatsApp"
            >
              <MessageCircle className="h-4 w-4" />
              WhatsApp
            </a>
          </div>
        </div>

        <div>
          <div className="mb-5 font-body text-[11px] uppercase tracking-[0.28em] text-[#D4AF37]">
            Contact
          </div>
          <ul className="space-y-3 font-body text-[14px] text-[#FDFBF7]/80">
            <li className="flex items-center gap-3">
              <Phone className="h-3.5 w-3.5 text-[#D4AF37]" />
              <a href="tel:+971528035188" className="hover:text-[#D4AF37] transition-colors">
                +971 52 803 5188
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-3.5 w-3.5 text-[#D4AF37]" />
              <a href="mailto:info@fairylights.ae" className="hover:text-[#D4AF37] transition-colors">
                info@fairylights.ae
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Globe className="h-3.5 w-3.5 text-[#D4AF37]" />
              www.fairylights.ae
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="mt-1 h-3.5 w-3.5 text-[#D4AF37]" />
              <span>Factory · Al Awir, Dubai</span>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="mt-1 h-3.5 w-3.5 text-[#D4AF37]" />
              <span>Office · Central Park Tower, Dubai</span>
            </li>
          </ul>
        </div>

        <div>
          <div className="mb-5 font-body text-[11px] uppercase tracking-[0.28em] text-[#D4AF37]">
            Wander
          </div>
          <ul className="space-y-3 font-body text-[14px] text-[#FDFBF7]/80">
            <li><a href="#work" className="hover:text-[#D4AF37] transition-colors">The Archive</a></li>
            <li><a href="#chapters" className="hover:text-[#D4AF37] transition-colors">Manifesto</a></li>
            <li><a href="#highlights" className="hover:text-[#D4AF37] transition-colors">Highlights</a></li>
            <li><a href="#contact" className="hover:text-[#D4AF37] transition-colors">Begin an enquiry</a></li>
          </ul>
        </div>
      </div>

      <div className="relative mx-auto mt-20 flex max-w-6xl flex-col items-start justify-between gap-4 border-t border-[#D4AF37]/20 pt-6 text-[11px] uppercase tracking-[0.24em] text-[#FDFBF7]/45 sm:flex-row sm:items-center">
        <span>© {year} Fairy Lights Parties & Events · UAE</span>
        <span className="font-italic-serif text-[13px] normal-case tracking-normal text-[#D4AF37]/70">
          Crafted with candlelight in Dubai.
        </span>
      </div>
    </footer>
  );
}
